module.exports = __webpack_public_path__ + "static/media/access_219.b1ef4f2a.ico";